import * as React from 'react';
import IFlag from './IFlag';
import FlagIcon from 'react-world-flags';
import countries from '@features/staticData/countries';

import * as style from './FlagStyle.module.scss'


const Flag = ({ slug }: IFlag) => {
  const country = countries.find(el => el.slug === slug.toUpperCase());

  return (
    country ? (
    <div className={style.flag}>
      <FlagIcon code={country.slug}/>
    </div>
    ) : null
  );
};

export default Flag;
